export default __webpack_public_path__ + "static/media/PhonChaNok-signature.79dc1965.png";